




import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'AudioItem',
  props: {
    type: String,
    link: String,
    name: String,
    filename: String,
  },
})
